export enum SearchResultsRoutePathsEnum {
  SEARCH_RESULTS = 'search-results',
}
